import type {SxProps} from '@mui/material';
import {useTheme} from '@mui/material';
import {useLocalization} from 'localization';
import {Icon, Layout, Spacer, Text} from 'components';

type Props = {
  type: 'expression' | 'work';
};

export const EmptyAncestorsWarning: React.FC<Props> = ({type}) => {
  const {t} = useLocalization();
  const {colors} = useTheme();
  const containerSx: SxProps = {
    backgroundColor: colors.warning40,
    borderRadius: 9999,
    mx: 1,
    my: 0.5,
    py: 1,
    pl: 1,
    pr: 1.5,
  };
  return (
    <Layout sx={containerSx} horizontal adjustCenter>
      <Icon icon="Info" fontSize="small" />
      <Spacer size={0.5} />
      <Text kind="primary" variant="body2">
        {t(`page.metadata.manifestation.tools.move.level2.${type}.warning`)}
      </Text>
    </Layout>
  );
};
